import { createContext } from "react";

import { AncillaryContentSubtype } from "../../../common/types/AncillaryContentType";
import { AncillaryItem } from "../listing/AncillaryItem";
import { UpdatedAncillaryItem } from "../listing/edit-ancillary-form/EditAncillaryForm";

interface IManageAncillaryContext {
    ancillaryContentType: AncillaryContentSubtype;
    ancillaryItems: AncillaryItem[];
    ancillariesToMerge: AncillaryItem[];
    setAncillaryItems(ancillaryItems: AncillaryItem[]): void;
    addAncillaryItem(ancillary: AncillaryItem): void;
    updateAncillaryItem(updatedAncillaryData: UpdatedAncillaryItem): void;
    addAncillaryToMerge(ancillaryItem: AncillaryItem): void;
    removeAncillaryToMerge(ancillaryItem: AncillaryItem): void;
    markAncillaryAsMerged(ancillaryId: string): void;
    clearAncillariesToMerge(): void;
}

const defaultManageAncillaryContext: IManageAncillaryContext = {} as IManageAncillaryContext;
export const ManageAncillaryContext = createContext<IManageAncillaryContext>(defaultManageAncillaryContext);
